{
  "name": "aptera",
  "author": {
    "name": "Amagno GmbH",
    "email": "info@amagno.de"
  },
  "version": "26.7.42",
  "engines": {
    "node": "24.22.1"
  },
  "scripts": {
    "ng": "ng",
    "preparestart": "npm run swagger:fetch && npm run swagger:update && npm run bfa:openapi:fetch && npm run bfa:openapi:update && npm run ai:openapi:fetch && npm run ai:openapi:update && npm run server:info",
    "prestart": "npm run preparestart",
    "prestart:secure": "npm run preparestart",
    "prestart:external": "npm run preparestart",
    "prestart:secure-external": "npm run preparestart",
    "start": "ng serve",
    "start:secure": "ng serve --ssl true",
    "start:external": "ng serve --host 0.0.0.0",
    "start:secure-external": "ng serve --ssl true --host 0.0.0.0",
    "start:production": "npm run build:prod && npm run httpserver",
    "start:mockserver": "npm run start --prefix mock-server",
    "generate:browser-support": "ts-node scripts/generate-browser-support.ts",
    "check:browser-support": "npm run browserslist:update && npm run generate:browser-support",
    "test:unsupported-browser": "ts-node scripts/launch-unsupported-browser.ts",
    "prebuild": "npm run generate:browser-support && npm run swagger:update && npm run bfa:openapi:update && npm run ai:openapi:update && npm run server:info && ts-node scripts/copy-file.ts src/webmanifest/dev/manifest.webmanifest src/manifest.webmanifest",
    "build": "ng build -c=dev",
    "prebuild:prod": "npm run generate:browser-support && npm run swagger:update && npm run bfa:openapi:update && npm run ai:openapi:update && ts-node scripts/copy-file.ts src/webmanifest/production/manifest.webmanifest src/manifest.webmanifest",
    "build:prod": "ng build -c=production",
    "httpserver": "npx http-server dist/aptera/browser --proxy http://localhost:8080? -S -C cert.pem -o",
    "test": "ng test",
    "test:electron": "cd electron && npm run electron:copy-shared-constants && node ../node_modules/.bin/vitest run",
    "test:coverage": "ng test --coverage",
    "lint": "ng lint",
    "lint:electron": "eslint electron/src",
    "lint:mock": "npm run lint --prefix mock-server",
    "lint:styles": "npx stylelint \"src/app/**/*.{css,scss}\"",
    "e2e": "ng e2e",
    "swagger:fetch": "curl --insecure https://app-dev.amagno.cloud/AmagnoMe/api/internal/swagger/docs/internal > swagger.json && npm run swagger:convert",
    "swagger:convert": "ts-node scripts/convert-openapi3-to-swagger2.ts swagger.json app-dev.amagno.cloud",
    "swagger:update": "ng-swagger-gen --config swagger-api-dev.json",
    "server:info:testing": "npx --yes echo-cli '{\"ServerVersion\":\"6.5\",\"ApiVersion\":\"1.0\"}' > server-information.json",
    "server:info": "curl --insecure https://app-dev.amagno.cloud/AmagnoMe/api/backend-for-app/server-information > server-information.json",
    "android:sync": "npx jetify && npm run build && npm run clean:well-known && npx cap sync android",
    "android:sync:dev": "BUILD_ENV=dev npm run android:sync",
    "android:sync:dev:windows": "set BUILD_ENV=dev& npm run android:sync",
    "android:open": "npm run android:sync && npx cap open android",
    "android:run": "ionic cap run android -l --external",
    "android:dev": "npm run android:open && ng serve --host 0.0.0.0",
    "clean:well-known": "node -e \"require('fs-extra').emptyDir('dist/aptera/.well-known');\"",
    "ios:sync": "cap sync ios",
    "ios:build-sync": "npm run build && cap sync ios",
    "ios:open": "npm run ios:sync && cap open ios",
    "ios:dev": "npm run ios:open && npm run start:secure-external",
    "ios:release:manual": "npm run build:prod && cap sync ios && cap copy ios && cap open ios",
    "start:electron": "cd electron && npm run build && npm run electron:start",
    "start:electron-build": "npm run build && ts-node scripts/sync-electron.ts --copy-only && cd electron && npm run build && npm run electron:start",
    "publish:electron:windows:production": "npm run build:prod && ts-node scripts/sync-electron.ts --copy-only && cd electron && npm run publish:windows:production",
    "publish:electron:windows:development": "npm run electron:set:name:dev && npm run build && ts-node scripts/sync-electron.ts --copy-only && cd electron && npm run publish:windows:development && cd .. && npm run electron:set:name:prod",
    "publish:electron:mac:development": "npm run electron:set:name:dev && npm run build && ts-node scripts/sync-electron.ts --copy-only && cd electron && npm run publish:mac:development && cd .. && npm run electron:set:name:prod",
    "publish:electron:mac:development:local": "npm run electron:set:name:dev && npm run build && ts-node scripts/sync-electron.ts --copy-only && cd electron && npm run publish:mac:development:local && cd .. && npm run electron:set:name:prod",
    "publish:electron:mac:development:mas": "npm run electron:set:name:dev && npm run build:prod && ts-node scripts/sync-electron.ts --copy-only && cd electron && npm run publish:mac:development:mas && cd .. && npm run electron:set:name:prod",
    "publish:electron:mac:production": "npm run build:prod && ts-node scripts/sync-electron.ts --copy-only && cd electron && npm run publish:mac:production",
    "publish:electron:mac:production:mas": "npm run build:prod && ts-node scripts/sync-electron.ts --copy-only && cd electron && npm run publish:mac:production:mas",
    "electron:sync": "npm run build && ts-node scripts/sync-electron.ts",
    "electron:set:name:prod": "ts-node scripts/set-electron-app-name.ts Amagno.App",
    "electron:set:name:dev": "ts-node scripts/set-electron-app-name.ts Amagno.Dev",
    "version": "ts-node scripts/set-version.ts",
    "postversion": "npm i",
    "buildVersion": "ts-node scripts/set-build-number.ts",
    "stats:build": "ng build --stats-json",
    "analyze-bundle": "ng build --configuration=analyze-bundle && source-map-explorer dist/**/*.js --no-border-checks",
    "svg:update": "npm run svg:step:clear-svg-icons-directory && npm run svg:step:svgo && npm run svg:step:create-const",
    "svg:step:clear-svg-icons-directory": "ts-node scripts/svg/clear-svg-icons-directory.ts",
    "svg:step:svgo": "svgo -f ./raw_svg_icons -o ./src/assets/icons --config ./svgo.config.js",
    "svg:step:create-const": "ts-node scripts/svg/create-svg-icon-const.ts",
    "bfa:openapi:fetch": "curl --insecure https://app-dev.amagno.cloud/AmagnoMe/api/backend-for-app/swagger/v1/swagger.json > openapi.json",
    "bfa:openapi:update": "ng-openapi-gen --config openapi-bfa-api.config.json",
    "test:e2e": "npm run test; clear; cd tests/e2e && npm run test:e2e",
    "test:e2e:windows": "npm run test & cls & cd tests/e2e && npm run test:e2e:windows",
    "test:e2e:tags": "npm run test; clear; cd tests/e2e && npm run test:e2e:tags --tags='\"${npm_config_tags}\"'",
    "test:e2e:tags:without-unit-tests": "cd tests/e2e && npm run test:e2e:tags --tags='\"${npm_config_tags} and not @unitTest\"'",
    "test:e2e:tags:windows": "npm run test & cls & cd tests/e2e && npm run test:e2e:tags:windows --tags='\"%npm_config_tags%\"'",
    "test:e2e:tags:windows:without-unit-tests": "cd tests/e2e && npm run test:e2e:tags:windows --tags='\"%npm_config_tags% and not @unitTest\"'",
    "ai:openapi:fetch": "curl --insecure https://ai.dev.amagno.cloud/swagger/v1/swagger.json > openapi-ai.json",
    "ai:openapi:update": "ng-openapi-gen --config openapi-ai-api.config.json",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org amagno-gmbh --project app ./dist/aptera && sentry-cli sourcemaps upload --org amagno-gmbh --project app ./dist/aptera",
    "browserslist:update": "npx ts-node scripts/grafana-data/convert-grafana-ga4-csv-to-browserslist-stats.ts scripts/grafana-data/grafana-ga4-export.csv && npx update-browserslist-db@latest"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^22.0.1",
    "@angular/common": "^22.0.1",
    "@angular/compiler": "^22.0.1",
    "@angular/core": "^22.0.1",
    "@angular/forms": "^22.0.1",
    "@angular/platform-browser": "^22.0.1",
    "@angular/platform-browser-dynamic": "^22.0.1",
    "@angular/router": "^22.0.1",
    "@angular/service-worker": "^22.0.1",
    "@azure/msal-angular": "^4.0.21",
    "@azure/msal-browser": "^4.26.1",
    "@capacitor-community/file-opener": "^7.0.1",
    "@capacitor/android": "^7.4.4",
    "@capacitor/app": "^7.1.0",
    "@capacitor/clipboard": "^7.0.2",
    "@capacitor/core": "^7.4.4",
    "@capacitor/device": "^7.0.2",
    "@capacitor/filesystem": "^7.1.4",
    "@capacitor/haptics": "^7.0.2",
    "@capacitor/inappbrowser": "^2.5.1",
    "@capacitor/ios": "^7.4.4",
    "@capacitor/keyboard": "^7.0.3",
    "@capacitor/share": "^7.0.2",
    "@capacitor/status-bar": "^7.0.3",
    "@capawesome/capacitor-android-edge-to-edge-support": "^7.2.3",
    "@electron/typescript-definitions": "^9.1.5",
    "@fontsource/inter": "^5.2.8",
    "@microsoft/signalr": "^9.0.6",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@sentry/angular": "10.60.0",
    "@sentry/capacitor": "^4.2.0",
    "@sentry/cli": "^2.58.4",
    "@vitest/coverage-v8": "^4.0.18",
    "bowser": "^2.12.1",
    "contactjs": "^2.1.7",
    "cordova-plugin-file-opener2": "^4.0.0",
    "cordova-plugin-intent": "^0.1.2",
    "es6-promise-plugin": "^4.2.2",
    "jetifier": "^2.0.0",
    "marked": "^17.0.0",
    "mime": "^4.1.0",
    "ng-swagger-gen": "^2.3.1",
    "replace-in-file": "^8.3.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.0.0",
    "@angular-eslint/eslint-plugin": "^22.0.0",
    "@angular-eslint/eslint-plugin-template": "^22.0.0",
    "@angular-eslint/schematics": "^22.0.0",
    "@angular-eslint/template-parser": "^22.0.0",
    "@angular/build": "^22.0.2",
    "@angular/cli": "^22.0.2",
    "@angular/compiler-cli": "^22.0.1",
    "@angular/localize": "^22.0.1",
    "@capacitor-community/electron": "^5.0.1",
    "@capacitor/cli": "^7.4.4",
    "@eslint/eslintrc": "^3.3.3",
    "@eslint/js": "^9.39.2",
    "@types/node": "^24.19.2",
    "@vitest/ui": "^4.0.18",
    "angular-eslint": "^22.0.0",
    "axe-core": "^4.14.0",
    "concurrently": "^9.2.1",
    "eslint": "^9.39.1",
    "eslint-plugin-compat": "^7.0.1",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jsdoc": "^61.1.12",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "eslint-plugin-unicorn": "^63.0.0",
    "happy-dom": "^20.4.0",
    "multiple-cucumber-html-reporter": "^3.9.3",
    "ng-openapi-gen": "^1.0.5",
    "source-map-explorer": "^2.5.3",
    "stylelint": "^17.11.0",
    "stylelint-config-standard": "^40.0.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-no-unsupported-browser-features": "^8.1.1",
    "svgo": "^4.0.0",
    "ts-node": "^10.9.2",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.61.1",
    "vitest": "^4.0.18"
  }
}
